import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { FAQS } from "@/data/site";
import { Reveal, SectionHead } from "./Reveal";

export const FAQ = () => (
  <section id="faq" className="relative py-28 lg:py-36 bg-ink" data-testid="faq-section">
    <div className="mx-auto max-w-[1440px] px-6 lg:px-12 grid lg:grid-cols-12 gap-14">
      <SectionHead index="07" eyebrow="Questions" title={<>Common questions.</>} className="lg:col-span-4" />
      <Reveal delay={0.15} className="lg:col-span-7 lg:col-start-6">
        <Accordion type="single" collapsible className="border-t border-gold/15" data-testid="faq-accordion">
          {FAQS.map((f, i) => (
            <AccordionItem key={f.q} value={`faq-${i}`} className="border-b border-gold/15" data-testid={`faq-item-${i}`}>
              <AccordionTrigger className="py-7 text-left font-serif text-xl sm:text-2xl text-ivory hover:no-underline hover:text-gold transition-colors [&>svg]:text-gold" data-testid={`faq-trigger-${i}`}>
                <span className="flex gap-6">
                  <span className="font-mono text-xs text-ivory/35 pt-2">0{i + 1}</span>
                  {f.q}
                </span>
              </AccordionTrigger>
              <AccordionContent className="pb-8 pl-12 text-ivory/60 leading-relaxed text-base">{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
